import React from "react";
import cn from "classnames";
import styles from "./Packages.module.sass";
import Tooltip from "../../../components/Tooltip";

const packages = [
	{
		title: "Power Farm Name",
		classTitle: "title-blue",
		recommended: false,
		content: "Basic farm on top of Aave using Wise Lending",
		percent: 8,
		note: "of the monthly income you earn on the market",
		tooltip: "Small description Lite",
		classButton: "button-stroke",
		buttonText: "Deposit Now",
		list: [
			"List Item Farm 1",
			"List Item Farm 2",
			"List Item Farm 3",
			"List Item Farm 4",
		],
	},
	{
		title: "Power Farm Name",
		classTitle: "title-purple",
		recommended: true,
		content:
			'Pro farm on top of Pendle <span role="img" aria-label="fire">🔥</span>',
		percent: 12,
		note: "of the monthly income you earn on the market",
		tooltip: "Small description Pro",
		classButton: "button",
		buttonText: "Deposit Now",
		list: [
			"List Item Farm 1",
			"List Item Farm 2",
			"List Item Farm 3",
			"List Item Farm 4",
			"List Item Farm 5",
			"List Item Farm 6",
		],
	},
];

const Packages = ({ className }) => {
	return (
		<div className={cn(styles.packages, className)}>
			<div className={styles.list}>
				{packages.map((x, index) => (
					<div className={styles.package} key={index}>
						<div className={styles.top}>
							<div className={cn(x.classTitle, styles.title)}>{x.title}</div>
							{x.recommended && (
								<div className={styles.recommended}>Recommended</div>
							)}
						</div>
						<div
							className={styles.content}
							dangerouslySetInnerHTML={{ __html: x.content }}
						></div>
						<div className={styles.line}>
							<div className={cn("h1", styles.percent)}>APY {x.percent}%</div>
							<div className={styles.note}>{x.note}</div>
							<Tooltip
								className={styles.tooltip}
								title={x.tooltip}
								icon="info"
								place="top"
							/>
						</div>
						<ul className={styles.group}>
							{x.list.map((item, index) => (
								<li className={styles.item} key={index}>
									{item}
								</li>
							))}
						</ul>
						<button className={cn(x.classButton, styles.button)}>
							{x.buttonText}
						</button>
					</div>
				))}
			</div>
		</div>
	);
};

export default Packages;
